import React from "react";

import { AdminLayoutMobile } from "../../";

export const AdminMobile = () => (
  <AdminLayoutMobile title="Admin Portal">
    <div>hi!</div>
  </AdminLayoutMobile>
);
